import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[domain]/[lang]/global.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DataDogInstallation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NavigatingBar/NavigatingBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/UmamiScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/UtilityComponents/EmptyState.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/WidgetsStyles/WidgetsStyles.ts");
;
import(/* webpackMode: "eager" */ "/app/src/i18n/i18n-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/analytics-accounts/AnalyticsAccounts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloProvider"] */ "/app/src/lib/apollo/apollo-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/Authentication/components/TryLogin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/app/src/lib/cartData/CartProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreProvider"] */ "/app/src/lib/storeData/StoreContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledProvider"] */ "/app/src/lib/styled-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/globals/UiElements/Flex.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalStyle"] */ "/app/src/shared/theme/globalStyle.ts");
